import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listagem-validacao',
  templateUrl: './listagem-validacao.component.html',
  styleUrls: ['./listagem-validacao.component.scss'],
})
export class ListagemValidacaoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
